<template>
    <section class="container-01">
        <h2>EXPERIENCE</h2>
        <ul>
            <li v-for="item in experience" :key="item.hash" class="container-03">
                <h3>{{ item.name }}</h3>
                <div class="subheadings">
                    <span class="summary">{{ item.type }}</span>
                    <span class="vl"></span>
                    <span class="summary">{{ item.location }}</span>
                </div>
                <p class="body">{{ item.description }}</p>
                <ul class="positions">
                    <li v-for="position in item.positions" :key="position.hash">
                        <ExperiencePosition :position="position" />
                        
                    </li>
                </ul>
                
            </li>
        </ul>
    </section>
</template>

<script lang="ts">
import { ResumeExperience } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

import ExperiencePosition from './ExperiencePosition.vue';
import ExperienceApp from './ExperienceApp.vue';

export default defineComponent({
    name: "experience",
    components: {
        // ExperienceApp
        ExperiencePosition
    },
    props: {
        experience: {
            type: Array as PropType<ResumeExperience[]>,
            required: true
        } 
    }
})
</script>

// TODO: Future, calculate year and month difference between start and end dates
// TODO: Monospaced font for dates

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

spacing = 10px

li 
   text-indent: 0
   list-style-type none
//    display: flex
//    gap 10px

ul
    // display flex
    // flex-direction column
    // gap 20px

// .subheadings span:not(:first-child)
//     // TODO: Shared location for colour
//     border-left 1px solid lightgray
//     padding-left spacing

.positions {
    margin-top: 8pt
    display flex
    flex-direction column
    gap: 12pt
}

.subheadings
    display flex
    gap spacing-08;
    align-items: center;

// .subsection span:not(:first-child)
//     // TODO: Shared location for colour
//     // border-left 1px solid lightgray
//     padding-left spacing/2

.subsection
    display flex
    gap spacing

.vl {
    border-right: 1px solid background
    height: 12pt
    display: inline-block;
}

</style>